import BlogGridView from "../../../commonComponents/blogGridView";

const BlogNoSidebarContainer = () => {
  return <BlogGridView side="no" carShow={12} gridSize={4} />;
};

export default BlogNoSidebarContainer;
